import React, { useEffect } from 'react';
import { Navbar, Image, Container } from "react-bootstrap";
import Seo from "../components/seo";
import { ScheduleMeetingMeta } from "../data/metaData";
import logo from '../images/green-logo.svg';
import { Link} from 'gatsby';

export const Head = () => (
  <Seo
    title={ScheduleMeetingMeta.metaTitle}
    description={ScheduleMeetingMeta.metaDescription}
    ogImage={ScheduleMeetingMeta.ogImage}
    twitterImage={ScheduleMeetingMeta.twitterImage}
  />
)

const ScheduleAMeeting = () => {
useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);

    // Cleanup in case the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return (

    <>
      <div className="wrapper">
        <main className="main-container">
          <section className="section text-center">
            <Container>
              <Navbar.Brand className="d-inline-block mb-0">
                 <Link to="/">
                <Image loading="lazy" className="lazyload" src={logo} width={200} height={48} alt="logo" />
                </Link>
              </Navbar.Brand>
              {/* <h1 className="title mb-3 mt-5">
                Schedule A Meeting
              </h1>
              <p className="lead mb-4">Please select a date and time from the calendar below to schedule your free call.</p> */}
              {/* <div className="ratio ratio-16x9" style={{ minHeight: 500 }} >
                <iframe className="lazyload" loading="lazy" width="100%" height="100%" src="https://meetings.hubspot.com/nakul-patel?embed=true" title="Schedule Call" frameBorder="0" allowFullScreen></iframe>
              </div> */}
              {/* <div class="calendly-inline-widget" data-url="https://calendly.com/nakul-p-xbi/30min" style="min-width:320px;height:630px;">
              <script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" async></script>
              </div> */}
               <div
        className="calendly-inline-widget"
        data-url="https://calendly.com/nakul-p-xbi/30min"
        style={{ minWidth: '320px', height: '667px' }}
      ></div>
            </Container>
          </section>
        </main>
      </div>
    </>
  );
};

export default ScheduleAMeeting;
